import { ALL_MACHINE } from "../apiEndpoints";
import MachinesList from "../components/MachinesList";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { useSelector } from "react-redux";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";

const MachinesPage = () => {
  const { isLoaded } = useFetchData(ALL_MACHINE);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;
  return (
    <MainPageLayout
      headerConfig={{ title: "Machines" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <MachinesList machinesData={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default MachinesPage;
